import * as React from "react";
const SvgPlayIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 6L0.75 11.1962L0.750001 0.803847L12 6Z", fill: "currentColor" }));
export default SvgPlayIcon;
